import React, { useContext } from "react";
import { observer } from "mobx-react";

import classNames from "classnames";
import CashoutActions from "@features/my-bets/desktop/common/CashoutActions";
import ShareBetSlipButton from "@features/my-bets/desktop/common/ShareBetSlipButton";
import ReuseButton from "@features/my-bets/desktop/common/ReuseButton";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function BetItemActions() {
	const bet = useContext(MyBetsBetContext);

	return (
		<div
			className={classNames("card--bet__actions no-print", {
				"card--bet__actions--full": bet.isCashoutUnavailable,
			})}
		>
			<CashoutActions />
			<ReuseButton />
			<ShareBetSlipButton bet={bet} />
		</div>
	);
});
